export enum MotorTradeBuySteps {
  Step1 = 'step1',
  Step2 = 'step2',
  Step3 = 'step3',
  Step4 = 'step4',
  Step5 = 'step5',
  Step6 = 'step6',
  Step7 = 'step7',
  Step8 = 'step8',
  Step9 = 'step9',
  Step10 = 'step10',
  Step11 = 'step11',
  Step12 = 'step12',
  Step13 = 'step13',
  Step14 = 'step14',
}

export enum MotorTradeS2 {
  Step1 = '/motortrade-roadrisks-s2/steps/step1',
  Step2 = '/motortrade-roadrisks-s2/steps/step2',
  Step3 = '/motortrade-roadrisks-s2/steps/step3',
  Step4 = '/motortrade-roadrisks-s2/steps/step4',
  Step5 = '/motortrade-roadrisks-s2/steps/step5',
  Step6 = '/motortrade-roadrisks-s2/steps/step6',
  Step7 = '/motortrade-roadrisks-s2/steps/step7',
  Step8 = '/motortrade-roadrisks-s2/steps/step8',
  Step9 = '/motortrade-roadrisks-s2/steps/step9',
  Step10 = '/motortrade-roadrisks-s2/steps/step10',
  Step11 = '/motortrade-roadrisks-s2/steps/step11',
  Step12 = '/motortrade-roadrisks-s2/steps/step12',
  Step13 = '/motortrade-roadrisks-s2/steps/step13',
  Step14 = '/motortrade-roadrisks-s2/steps/step14',
}

export enum MotorTradeRTL {
  Step1 = '/motortrade-roadrisks-rtl/steps/step1',
  Step2 = '/motortrade-roadrisks-rtl/steps/step2',
  Step3 = '/motortrade-roadrisks-rtl/steps/step3',
  Step4 = '/motortrade-roadrisks-rtl/steps/step4',
  Step5 = '/motortrade-roadrisks-rtl/steps/step5',
  Step6 = '/motortrade-roadrisks-rtl/steps/step6',
  Step7 = '/motortrade-roadrisks-rtl/steps/step7',
  Step8 = '/motortrade-roadrisks-rtl/steps/step8',
  Step9 = '/motortrade-roadrisks-rtl/steps/step9',
  Step10 = '/motortrade-roadrisks-rtl/steps/step10',
  Step11 = '/motortrade-roadrisks-rtl/steps/step11',
  Step12 = '/motortrade-roadrisks-rtl/steps/step12',
  Step13 = '/motortrade-roadrisks-rtl/steps/step13',
  Step14 = '/motortrade-roadrisks-rtl/steps/step14',
}

export enum MotorTradeS2RTL {
  Step1 = '/motortrade-roadrisks-s2-rtl/steps/step1',
  Step2 = '/motortrade-roadrisks-s2-rtl/steps/step2',
  Step3 = '/motortrade-roadrisks-s2-rtl/steps/step3',
  Step4 = '/motortrade-roadrisks-s2-rtl/steps/step4',
  Step5 = '/motortrade-roadrisks-s2-rtl/steps/step5',
  Step6 = '/motortrade-roadrisks-s2-rtl/steps/step6',
  Step7 = '/motortrade-roadrisks-s2-rtl/steps/step7',
  Step8 = '/motortrade-roadrisks-s2-rtl/steps/step8',
  Step9 = '/motortrade-roadrisks-s2-rtl/steps/step9',
  Step10 = '/motortrade-roadrisks-s2-rtl/steps/step10',
  Step11 = '/motortrade-roadrisks-s2-rtl/steps/step11',
  Step12 = '/motortrade-roadrisks-s2-rtl/steps/step12',
  Step13 = '/motortrade-roadrisks-s2-rtl/steps/step13',
  Step14 = '/motortrade-roadrisks-s2-rtl/steps/step14',
}
